// LIBRERIE/IMPORTS
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// COMPONENTI
import Loader from "../Loaders/Loader";

// CONFIGURAZIONI
import appConfig, { DEFAULT_AGENCY_NAME } from "../../config/appConfig";

const LanguageRouteHandler = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [isLanguageSet, setIsLanguageSet] = useState(false);

  useEffect(() => {
    if (!i18n.isInitialized) {
      return;
    }

    if (appConfig.integrations.multilang) {
      const pathSegments = location.pathname.split("/").filter(Boolean);
      const lng = pathSegments[0];

      let supportedLngs: string[] = [];
      if (i18n.options.supportedLngs && Array.isArray(i18n.options.supportedLngs)) {
        supportedLngs = i18n.options.supportedLngs.filter(l => l !== 'cimode') as string[];
      } else if (i18n.options.supportedLngs) {
        supportedLngs = Object.keys(i18n.options.supportedLngs).filter(l => l !== 'cimode');
      }

      if (supportedLngs.length === 0 && i18n.options.fallbackLng) {
        if (typeof i18n.options.fallbackLng === 'string') supportedLngs.push(i18n.options.fallbackLng);
        else if (Array.isArray(i18n.options.fallbackLng)) supportedLngs.push(...i18n.options.fallbackLng as string[]);
        else if (typeof i18n.options.fallbackLng === 'object') supportedLngs.push(...Object.keys(i18n.options.fallbackLng));
      }

      const detectedLng = i18n.language.split('-')[0];

      if (!lng || !supportedLngs.includes(lng)) {
        const newPath = `/${detectedLng}${location.pathname === '/' ? '' : location.pathname}`;
        navigate(newPath + location.search, { replace: true });
        return;
      }

      if (lng !== i18n.language) {
        i18n.changeLanguage(lng).then(() => setIsLanguageSet(true));
      } else {
        setIsLanguageSet(true);
      }
    } else {
      setIsLanguageSet(true);
    }
  }, [location.pathname, navigate, i18n, i18n.isInitialized, i18n.language]);
  
  if (!isLanguageSet || !i18n.isInitialized) {
    return <Loader agencyData={{ agency_name: DEFAULT_AGENCY_NAME }} isLoading={true} />;
  }

  return <>{children}</>;
};

export default LanguageRouteHandler;